import { ActionIcon, AppShell, Group } from '@mantine/core';
import { Outlet, useNavigate } from 'react-router-dom';
import { FC, useContext, useEffect } from 'react';
import { IconArrowLeft } from '@tabler/icons';
import { WindowContext } from '../../../Service/Context/WindowContext';
import DoubleNavbar from '../../../Molecules/DoubleNavbar';
import PageHeader from '../../Navigation/PageHeader';
import { RoutingS } from '../../../Service/RoutingS';
import ContactDetailsFooter from '../../Navigation/phone/ContactDetailsFooter';
import BookitupFooter from '../../Navigation/phone/BookitupFooter';
import { EmailBoxContext } from '../../../Service/Context/EmailBoxContext';
import EmailPageFooter from '../../Navigation/phone/EmailPageFooter';
import ContactDetailsNavBar from './ContactNavBar';
import ContactTile from './ContactTile';

const ContactPage: FC = () => {
  const { sm } = useContext(WindowContext);
  const navigate = useNavigate();
  const { selectedMessage } = useContext(EmailBoxContext);

  useEffect(() => {
    RoutingS.changeTitle('Kontaktdaten');
  }, []);

  return (
    <AppShell
      header={
        <PageHeader
          height={60}
          subheader={
            <Group p="sm" spacing="xs">
              <ActionIcon ml={5} mr="xs" onClick={() => navigate('/contacts')}>
                <IconArrowLeft />
              </ActionIcon>
              <ContactTile />
            </Group>
          }
        />
      }
      navbar={
        !sm ? (
          <DoubleNavbar>
            <ContactDetailsNavBar />
          </DoubleNavbar>
        ) : undefined
      }
      styles={(theme) => ({
        main: { backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'inherit' },
      })}
      footer={
        sm ? (
          <BookitupFooter>{selectedMessage ? <EmailPageFooter /> : <ContactDetailsFooter />}</BookitupFooter>
        ) : undefined
      }
    >
      <Outlet />
    </AppShell>
  );
};

export default ContactPage;
